import { truncate } from '@aipb/util/string';
import { Pipe, PipeTransform } from '@angular/core';

const DEFAULT_LIMIT = 96;

@Pipe({
  name: 'truncate',
  standalone: true
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit: number = DEFAULT_LIMIT, append = '...'): string {
    return truncate(value, limit, append);
  }
}
